import { BaseTemplateElement } from './base-template-element.model';
import { Base } from './report-editor.model';
import {
    DatapointFiltersDto,
    HistoricalDatapointDto,
    InOperationFilterTypeDto,
    KpiCoordinatesDto,
    KpiLimitsDto,
    LegendDto,
    ScatterplotKpiDto,
} from './template-dto.model';

export class ScatterPlotChartElement extends BaseTemplateElement {
    description: string;
    datapoints: HistoricalDatapointDto[];
    kpi: ScatterplotKpiDto;
    legend: LegendDto[];
    inOperationFilterType: InOperationFilterTypeDto;
    datapointFilters: DatapointFiltersDto[];
    useTitle?: boolean;

    constructor(
        base: Base,
        description: string,
        datapoints: HistoricalDatapointDto[],
        kpi: ScatterplotKpiDto,
        legend: LegendDto[],
        inOperationFilterType: InOperationFilterTypeDto,
        datapointFilters: DatapointFiltersDto[],
    ) {
        super(base);
        this.description = description;
        this.datapoints = datapoints;
        this.kpi = kpi;
        this.legend = legend;
        this.inOperationFilterType = inOperationFilterType;
        this.datapointFilters = datapointFilters;
    }
}

export class ScatterPlotKpiCoordinates implements KpiCoordinatesDto {
    datapointId: HistoricalDatapointDto;
    values: number[];

    constructor(datapointId: HistoricalDatapointDto, values: number[]) {
        this.datapointId = datapointId;
        this.values = values;
    }
}

export class ScatterPlotKpiLimits implements KpiLimitsDto {
    above: number;
    below: number;

    constructor(above: number, below: number) {
        this.above = above;
        this.below = below;
    }
}

export class ScatterPlotKpi implements ScatterplotKpiDto {
    id: string;
    coordinates: ScatterPlotKpiCoordinates[];
    limits: ScatterPlotKpiLimits;
    target: number;

    constructor(
        id: string,
        coordinates: ScatterPlotKpiCoordinates[],
        limits: ScatterPlotKpiLimits,
        target: number,
    ) {
        this.id = id;
        this.coordinates = coordinates;
        this.limits = limits;
        this.target = target;
    }
}
